import { matchPath, useLocation } from 'react-router';
import { DiscoveryCall, discoveryCallsList } from './discoveryCallsList';
import { DiscoveryCallSurvey } from './DiscoveryCallSurvey';
import { useDiscoveryCallsFlag } from './useDiscoveryCallsFlag';

const DiscoveryCallFeatureFlagCheck = ({
  discoveryCall,
}: {
  discoveryCall: DiscoveryCall;
}) => {
  const flag = useDiscoveryCallsFlag(discoveryCall.featureFlagSlug);

  const calendlyLink = flag?.calendlyLink;
  const isEnabled = !!(flag?.enabled && calendlyLink);

  return isEnabled ? (
    <DiscoveryCallSurvey
      discoveryCall={discoveryCall}
      calendlyLink={calendlyLink}
    />
  ) : null;
};

export const DiscoveryCalls = () => {
  const location = useLocation();

  const match = discoveryCallsList.find(({ triggerUrl }) =>
    matchPath(location.pathname, { path: triggerUrl, exact: true })
  );

  if (match) {
    return <DiscoveryCallFeatureFlagCheck discoveryCall={match} />;
  }

  return null;
};
